module.exports = __webpack_public_path__ + "aha-to-canny-ea239eed7dfcb2ca9e79d5c502d49c15.webp";